import React from 'react';
import PropTypes from 'prop-types';

const PlusEdge = ({ theme, fill, ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="8" r="8" fill="#6930CA" />
    <circle cx="7.99978" cy="8.00174" r="7.11111" fill="white" />
    <path
      d="M8.36211 7.63779L8.36205 5.84405L8.36049 5.81195C8.33851 5.62028 8.18427 5.482 8 5.482C7.8138 5.482 7.65852 5.62313 7.63982 5.80724L7.63818 5.8354L7.63803 7.63766L5.84417 7.63783L5.81177 7.63943C5.63354 7.66003 5.50111 7.79442 5.48399 7.96307L5.48234 7.99123L5.48242 8.00985L5.48372 8.03228C5.50433 8.21051 5.63871 8.34294 5.80736 8.36007L5.83552 8.36171L7.63791 8.36174L7.63797 10.1557L7.63917 10.1839C7.65853 10.3766 7.81381 10.5178 8.00002 10.5178L8.02815 10.5166L8.05815 10.5124C8.2354 10.4808 8.36207 10.3321 8.36207 10.1557L8.36199 8.36187L10.1559 8.36194L10.184 8.36074C10.3768 8.34138 10.5179 8.1861 10.5179 7.9999C10.5179 7.79994 10.3558 7.63785 10.1559 7.63785L8.36211 7.63779Z"
      fill="#6930CA"
      stroke="#6930CA"
      strokeWidth="0.5"
    />
  </svg>
);

PlusEdge.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default PlusEdge;
